import type { GalleryItem } from '@components/PickGallery';

export enum ConnectionStatus {
  Connected = 'Connected',
  NotConnected = 'Not Connected',
}

export interface IntegrationSource extends GalleryItem {
  type: string;
  name: string;
  vendorName: string;
  category: string;
  classifications?: string[];
  tag?: string;
  hasDefaultMapping?: boolean;
  authenticationSourceType?: string;
  disabled?: boolean;
  description?: string;
  group?: ConnectionStatus;
  searchTerms?: string[];
  bundleId?: string;
}

export interface DefaultMappingModalData {
  name: string;
  type: string;
}

export const SOURCE_CATEGORIES = [
  'Vulnerability Databases',
  'Cloud',
  'Upload',
  'Application',
  'Network',
  'Host',
  'Enrichment',
  'Vulnerability Scanners',
] as const;
